import React from "react";
import { ResponsiveLine } from "@nivo/line";
import "../LineChart/LineChart.css";

// Updated sample data for compliance benchmarking with more data points
const data = [
  {
    id: "Compliance Scores",
    data: [
      { x: "USA", y: 90 },
      { x: "UK", y: 80 },
      { x: "Germany", y: 75 },
      { x: "India", y: 70 },
      { x: "Island", y: 50 },
      { x: "France", y: 85 },
      { x: "Australia", y: 88 },
      { x: "China", y: 60 },
    ],
  },
  {
    id: "Global Benchmark",
    data: [
      { x: "USA", y: 55 },
      { x: "UK", y: 75 },
      { x: "Germany", y: 92 },
      { x: "India", y: 80 },
      { x: "Island", y: 30 },
      { x: "France", y: 70 },
      { x: "Australia", y: 78 },
      { x: "China", y: 65 },
    ],
  },
  {
    id: "Regional Benchmark",
    data: [
      { x: "USA", y: 65 },
      { x: "UK", y: 60 },
      { x: "Germany", y: 80 },
      { x: "India", y: 65 },
      { x: "Island", y: 40 },
      { x: "France", y: 72 },
      { x: "Australia", y: 80 },
      { x: "China", y: 58 },
    ],
  },
];

const LineChart = () => {
  return (
    <>
      <section className="section">
        <div className="line-container">
          <div className="line-header">
            <h1>Compliance Benchmarking Across Countries</h1>
          </div>

          <div className="line-parent">
            <div className="line-count-wrapper">
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#bdbdbd" }}
                ></i>{" "}
                Compliance Scores
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#6373f1" }}
                ></i>{" "}
                Global Benchmark
              </div>
              <div>
                <i
                  className="fa-solid fa-circle"
                  style={{ color: "#fdcc70" }}
                ></i>{" "}
                Regional Benchmark
              </div>
            </div>

            <div className="line-chart-container">
              <ResponsiveLine
                height={350}
                // height="100%"
                data={data}
                margin={{ top: 10, right: 30, bottom: 100, left: 60 }}
                xScale={{ type: "point" }}
                yScale={{
                  type: "linear",
                  min: 0,
                  max: 100,
                  stacked: false,
                  reverse: false,
                }}
                yFormat=" >-.2f"
                axisTop={null}
                axisRight={null}
                axisBottom={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Countries",
                  legendOffset: 50,
                  legendPosition: "start",
                }}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Compliance Score",
                  legendOffset: -50,
                  legendPosition: "start",
                }}
                pointSize={10}
                pointColor={{ theme: "background" }}
                pointBorderWidth={2}
                pointBorderColor={{ from: "serieColor" }}
                pointLabel="data.yFormatted"
                pointLabelYOffset={-12}
                enableTouchCrosshair={true}
                useMesh={true}
                tooltip={({ point }) => (
                  <div
                    style={{
                      padding: "10px",
                      background: "#fff",
                      color: "#000",
                      borderWidth: 1,
                      borderColor: "#000",
                      borderStyle: "solid",
                      borderRadius: "5px",
                      fontSize: "14px",
                    }}
                  >
                    <strong>{point.serieId}</strong>
                    <br />
                    <strong>{point.data.xFormatted}</strong>:{" "}
                    {point.data.yFormatted}
                  </div>
                )}
                colors={["#bdbdbd", "#6373f1", "#fdcc70"]}
                theme={{
                  axis: {
                    ticks: {
                      text: {
                        fontSize: 14,
                        fill: "#999",
                      },
                    },
                    legend: {
                      text: {
                        fontSize: 14,
                        fill: "#999",
                      },
                    },
                  },
                  legends: {
                    text: {
                      fontSize: 14,
                      fill: "#999",
                    },
                  },
                  tooltip: {
                    container: {
                      fontSize: "14px",
                      color: "#999",
                    },
                  },
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LineChart;
